import React, { useState, useRef } from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useOutsideClick from 'utils/useOutsideClick';
import EditRowMenu from './components/editRowMenu';

const TableRow = ({
  editingRow,
  rowData,
  author,
  rowIndex,
  startEditing,
  isValid,
  isEditing,
  setRow,
  onDelete,
  canEditPage,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const inputRef = useRef();
  const ref = useRef();
  useOutsideClick(ref, () => {
    setShowMenu(false);
  });
  const isFirstColumn = (columnNumber) => columnNumber === 0;
  const isFirstRow = (rowNumber) => rowNumber === 0;
  return (
    <tr
      className={classNames({
        'editable-row': true,
        'editable-row--edit': showMenu || isEditing,
      })}
      ref={ref}
    >
      {rowData
        .filter((el) => el.visible)
        .map(
          ({ name, value, disabled, error, placeholder, component }, index) => (
            <td
              key={`${rowIndex}-${index}`}
              className={classNames({
                'editable-row__td-menu': isFirstColumn(index) && !isEditing,
                'editable-row__td-menu__disabled': !canEditPage,
                'table-column__input--error': error && !isValid,
                'table-column__input': true,
              })}
              style={{ padding: '0.5rem', width: 'unset' }}
            >
              {isEditing && !disabled ? (
                <>
                  <div
                    className="table-column__input-container"
                    style={{ padding: '0.5rem', width: 'unset' }}
                  >
                    <Input
                      type={component}
                      ref={inputRef}
                      defaultValue={editingRow[name]}
                      placeholder={placeholder}
                      onChange={(e) =>
                        setRow({
                          ...editingRow,
                          [name]: e.target.value,
                        })
                      }
                    />
                  </div>
                  {error ? (
                    <div className="table-column__error">{error}</div>
                  ) : null}
                </>
              ) : (
                <div
                  className={classNames({
                    note: component === 'textarea',
                    'table-column__input': true,
                  })}
                  style={{ padding: '0.5rem', width: 'unset' }}
                  onClick={() =>
                    isFirstColumn(index) && !isEditing && setShowMenu(!showMenu)
                  }
                >
                  {value}
                  {canEditPage && showMenu && isFirstColumn(index) && (
                    <EditRowMenu
                      isFirstRow={isFirstRow(rowIndex)}
                      lastEdited={author}
                      onEdit={() =>
                        startEditing(
                          rowData.reduce((acum, el) => {
                            acum[el.name] = el.value;
                            return acum;
                          }, {}),
                          rowIndex,
                        )
                      }
                      onDelete={onDelete}
                    />
                  )}
                </div>
              )}
            </td>
          ),
        )}
    </tr>
  );
};

TableRow.propTypes = {
  rowData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      disabled: PropTypes.bool,
      label: PropTypes.string,
      placeholder: PropTypes.string,
      value: PropTypes.any,
      error: PropTypes.string,
      component: PropTypes.string,
      visible: PropTypes.bool,
    }),
  ).isRequired,
  editingRow: PropTypes.shape({}),
  isValid: PropTypes.bool,
  author: PropTypes.shape().isRequired,
  rowIndex: PropTypes.number.isRequired,
  startEditing: PropTypes.func.isRequired,
  isEditing: PropTypes.bool,
  setRow: PropTypes.func,
  onDelete: PropTypes.func,
  canEditPage: PropTypes.bool,
};

export default TableRow;
